import { useId } from 'react';
import { Text } from '~/components/ui/Text';
import { StyledContainer } from './Key.styled';

const Key = ({ name, active }: { name: string; active?: boolean }) => {
	const gradientId1 = useId();
	const gradientId2 = useId();
	return (
		<StyledContainer $active={active}>
			<svg width="30" height="30" viewBox="0 0 30 30" fill="none">
				<rect
					x="1"
					y="1"
					width="28"
					height="28"
					rx="9"
					fill={`url(#${gradientId1})`}
				/>
				<rect
					x="1"
					y="1"
					width="28"
					height="28"
					rx="9"
					stroke={`url(#${gradientId2})`}
					strokeWidth="2"
				/>
				<defs>
					<linearGradient
						id={gradientId1}
						x1="15"
						y1="30"
						x2="15"
						y2="0"
						gradientUnits="userSpaceOnUse"
					>
						<stop
							className="stop-1-start"
							stopColor={active ? '#272727' : '#EEEEEE'}
						/>
						<stop
							className="stop-1-end"
							offset="1"
							stopColor={active ? '#101010' : '#B2B2B2'}
						/>
					</linearGradient>
					<linearGradient
						id={gradientId2}
						x1="15"
						y1="0"
						x2="15"
						y2="30"
						gradientUnits="userSpaceOnUse"
					>
						<stop
							className="stop-2-start"
							offset="0.552885"
							stopColor={active ? 'white' : 'transparent'}
							stopOpacity="0"
						/>
						<stop
							className="stop-2-end"
							offset="1"
							stopColor={active ? 'white' : 'transparent'}
							stopOpacity={active ? 0.1 : 0.25}
						/>
					</linearGradient>
				</defs>
			</svg>

			<Text>{name}</Text>
		</StyledContainer>
	);
};

export { Key };
